import React from "react";
import { Link } from "react-router-dom";
import { Home, Compass, Mail, AlertTriangle } from "lucide-react";
import SEO from "../components/SEO";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found-page-wrapper">
      <SEO
        title="404 - Page Not Found | D Base Solutions Pvt Ltd"
        description="The page you are looking for does not exist or has been moved. Explore D Base Solutions products and services."
        noIndex={true}
      />
      <div className="not-found-content-box">
        <div className="not-found-badge">
          <AlertTriangle size={18} />
          <span>Error 404</span>
        </div>
        <h1 className="not-found-glitch-title">404</h1>
        <h2 className="not-found-subheading">Page Not Found</h2>
        <p className="not-found-description">
          The requested URL does not exist or has been relocated. If you arrived here via an outdated link, please navigate to one of our verified official pages below.
        </p>

        <div className="not-found-actions">
          <Link to="/" className="not-found-btn primary">
            <Home size={18} />
            <span>Return to Homepage</span>
          </Link>
          <Link to="/products" className="not-found-btn secondary">
            <Compass size={18} />
            <span>Explore Products</span>
          </Link>
          <Link to="/contact" className="not-found-btn tertiary">
            <Mail size={18} />
            <span>Contact Support</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
